/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: oB885NJtg5rwT11s7yCnwW
// Component: i-BferDjrAl

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicIcon as PlasmicIcon__,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import ListItem from "../../components/ListItem"; // plasmic-import: v31d9_ANqk/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: oB885NJtg5rwT11s7yCnwW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_find_references_modal.css"; // plasmic-import: oB885NJtg5rwT11s7yCnwW/projectcss
import sty from "./PlasmicReferenceItem.module.css"; // plasmic-import: i-BferDjrAl/css

import ComponentIcon from "../plasmic_kit/PlasmicIcon__Component"; // plasmic-import: nNWEF4jI3s5DI/icon
import FrameIcon from "../plasmic_kit/PlasmicIcon__Frame"; // plasmic-import: nMkHNFwp_HRuJ/icon
import MixinIcon from "../plasmic_kit/PlasmicIcon__Mixin"; // plasmic-import: XA82Nhrgqj98Z/icon
import ThemeIcon from "../plasmic_kit/PlasmicIcon__Theme"; // plasmic-import: jzPNgxwRto4ES/icon
import TokenIcon from "../plasmic_kit/PlasmicIcon__Token"; // plasmic-import: 2dOodD9TzfBr7/icon
import PageIcon from "../plasmic_kit_design_system/icons/PlasmicIcon__Page"; // plasmic-import: p8KOsO82kk/icon
import PresetsIcon from "../plasmic_kit_design_system/PlasmicIcon__Presets"; // plasmic-import: B_JznpDb3g/icon
import ChevronBottomIcon from "./icons/PlasmicIcon__ChevronBottom"; // plasmic-import: QWzHJOf09S/icon
import ChevronRightIcon from "./icons/PlasmicIcon__ChevronRight"; // plasmic-import: uFvmqTmkO9/icon

createPlasmicElementProxy;

export type PlasmicReferenceItem__VariantMembers = {
  type: "page" | "component" | "token" | "mixin" | "preset" | "theme" | "frame";
  selected: "selected";
};
export type PlasmicReferenceItem__VariantsArgs = {
  type?: SingleChoiceArg<
    "page" | "component" | "token" | "mixin" | "preset" | "theme" | "frame"
  >;
  selected?: SingleBooleanChoiceArg<"selected">;
};
type VariantPropType = keyof PlasmicReferenceItem__VariantsArgs;
export const PlasmicReferenceItem__VariantProps = new Array<VariantPropType>(
  "type",
  "selected"
);

export type PlasmicReferenceItem__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicReferenceItem__ArgsType;
export const PlasmicReferenceItem__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicReferenceItem__OverridesType = {
  root?: Flex__<"div">;
  listItem?: Flex__<typeof ListItem>;
};

export interface DefaultReferenceItemProps {
  children?: React.ReactNode;
  type?: SingleChoiceArg<
    "page" | "component" | "token" | "mixin" | "preset" | "theme" | "frame"
  >;
  selected?: SingleBooleanChoiceArg<"selected">;
  className?: string;
}

const $$ = {};

function PlasmicReferenceItem__RenderFunc(props: {
  variants: PlasmicReferenceItem__VariantsArgs;
  args: PlasmicReferenceItem__ArgsType;
  overrides: PlasmicReferenceItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.type,
      },
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.selected,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_oB885NJtg5rwT11s7yCnwW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootselected]: hasVariant($state, "selected", "selected"),
          [sty.roottype_component]: hasVariant($state, "type", "component"),
          [sty.roottype_page]: hasVariant($state, "type", "page"),
        }
      )}
    >
      <ListItem
        data-plasmic-name={"listItem"}
        data-plasmic-override={overrides.listItem}
        className={classNames("__wab_instance", sty.listItem, {
          [sty.listItemselected]: hasVariant($state, "selected", "selected"),
          [sty.listItemtype_page]: hasVariant($state, "type", "page"),
        })}
        icon={
          <React.Fragment>
            {false ? (
              <ChevronBottomIcon
                className={classNames("all", sty.svg__hpcVh)}
                role={"img"}
              />
            ) : null}
            {false ? (
              <ChevronRightIcon
                className={classNames("all", sty.svg__g3Nlv)}
                role={"img"}
              />
            ) : null}
            <PlasmicIcon__
              PlasmicIconType={
                hasVariant($state, "type", "frame")
                  ? FrameIcon
                  : hasVariant($state, "type", "theme")
                  ? ThemeIcon
                  : hasVariant($state, "type", "preset")
                  ? PresetsIcon
                  : hasVariant($state, "type", "mixin")
                  ? MixinIcon
                  : hasVariant($state, "type", "token")
                  ? TokenIcon
                  : hasVariant($state, "type", "page")
                  ? PageIcon
                  : ComponentIcon
              }
              className={classNames("all", sty.svg__yn2Mk, {
                [sty.svgtype_component__yn2Mkkyowq]: hasVariant(
                  $state,
                  "type",
                  "component"
                ),
                [sty.svgtype_frame__yn2MkQy1Ub]: hasVariant(
                  $state,
                  "type",
                  "frame"
                ),
                [sty.svgtype_mixin__yn2MkL37]: hasVariant(
                  $state,
                  "type",
                  "mixin"
                ),
                [sty.svgtype_page__yn2Mks0Z3C]: hasVariant(
                  $state,
                  "type",
                  "page"
                ),
                [sty.svgtype_preset__yn2MkYqyAh]: hasVariant(
                  $state,
                  "type",
                  "preset"
                ),
                [sty.svgtype_theme__yn2MkkuTx8]: hasVariant(
                  $state,
                  "type",
                  "theme"
                ),
                [sty.svgtype_token__yn2MknHsTc]: hasVariant(
                  $state,
                  "type",
                  "token"
                ),
              })}
              role={"img"}
            />
          </React.Fragment>
        }
        isSelected={
          hasVariant($state, "selected", "selected") ? true : undefined
        }
      >
        {renderPlasmicSlot({
          defaultContents: "Item name",
          value: args.children,
        })}
      </ListItem>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "listItem"],
  listItem: ["listItem"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  listItem: typeof ListItem;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicReferenceItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicReferenceItem__VariantsArgs;
    args?: PlasmicReferenceItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicReferenceItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicReferenceItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicReferenceItem__ArgProps,
          internalVariantPropNames: PlasmicReferenceItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicReferenceItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicReferenceItem";
  } else {
    func.displayName = `PlasmicReferenceItem.${nodeName}`;
  }
  return func;
}

export const PlasmicReferenceItem = Object.assign(
  // Top-level PlasmicReferenceItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    listItem: makeNodeComponent("listItem"),

    // Metadata about props expected for PlasmicReferenceItem
    internalVariantProps: PlasmicReferenceItem__VariantProps,
    internalArgProps: PlasmicReferenceItem__ArgProps,
  }
);

export default PlasmicReferenceItem;
/* prettier-ignore-end */
